import { shade } from 'polished';
import React from 'react';
import { Colors } from '../../../ui';

export const BuzzerPreview = ({ width, height, color }: { width?: string, height?: string, color?: string }) => {
    color = color || '#c3352b';
    const shadeColor = shade(0.2, color);
    return <svg width={width} height={height} viewBox="0 0 66 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="65" height="67" rx="32.5" fill={Colors.border} stroke={Colors.border} />
        <rect x="0.5" y="0.5" width="65" height="65" rx="32.5" fill="white" stroke={Colors.border} />
        <rect x="8" y="4" width="50" height="54" rx="25" fill={shadeColor} />
        <rect x="8" y="4" width="50" height="48" rx="24" fill={color} />
    </svg>;
};

